export default class Terminart {
    public static readonly DefaultColor = '#ADADAD';
    public static readonly ErschienenColor = '#FFFFFF';

    public static readonly DefaultFontColor = '#FFFFFF';
    public static readonly ErschienenFontColor = '#000000';

    public static readonly Frei = 'FREI';

    /** PK: TK_Terminart | erforderlich **/
    public terminart: number | null = null;
    /** Bezeichnung | max. 100 Zeichen **/
    public bezeichnung: string | null = null;
    /** Standard Terminart | max. 1 Zeichen j/n **/
    public standard: string | null = null;
    /** Farbe in hex | max. 7 Zeichen **/
    public color: string | null = Terminart.DefaultColor;
    /** Schriftfarbe in hex | max. 7 Zeichen **/
    public textcolor: string | null = Terminart.DefaultFontColor;
    /** Datensatz gültig j/n | max. 1 Zeichen **/
    public gueltig: string | null = 'j';

    constructor(data?: Partial<Terminart>) {
        Object.assign(this, data);
    }
}
